export default {
  facilities: [],
  facility: null,

  loading: false,
  error: null,
  message: null,

  
  // filters & pagination
  filters: {
    page: 1,
    per_page: 10,
    role: null,
    search: ''
  },

  pagination: {
    total: 0,
    current_page: 1,
    last_page: 1
  }
}